/** @format */
import {DiscretenessModel} from './model';

export const WEEK_DAYS = 7;

export const QUARTER_DAYS = 90;

export const HALF_YEAR_DAYS = 183;

export const FUTURE_THRESHOLD_DAYS = 1;

export const DISCRETENESS_LIST: DiscretenessModel[] = [
  {
    key: 'day',
    name: 'Дни',
  },
  {
    key: 'week',
    name: 'Недели',
  },
  {
    key: 'month',
    name: 'Месяцы',
  },
];

export const HINT_DELAY = 100;
